import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'

Vue.config.productionTip = false

import Vuex from 'vuex'
Vue.use(Vuex)

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import axios from 'axios'

Vue.prototype.$http = axios

import { store } from './store/store.js';
new Vue({
    vuetify,
    router,
    store,
    
    render: h => h(App)
}).$mount('#app')


axios.interceptors.response.use(
    response => {    
        if (response.status === 200) {        
          return Promise.resolve(response);        
        } else {        
          return Promise.reject(response);        
        }        

    },
    error => {
        if (error.response.status) {
            switch (error.response.status) {             
                case 401:
                    if(error.response.data.detail == 'No active account found with the given credentials'){
                        alert('Fail to log in. Please check your account and password')
                    }
                    else{
                        alert('Please login')
                        router.replace({                   
                            path: "/login",                    
                            query: {                    
                              redirect: router.currentRoute.fullPath                    
                            }                    
                        });
                    }
                    
                    break;                
                case 403:                    
                    // console.error('403')
                    alert('Permission denied')
                    router.replace({                   
                        path: "/login",                    
                        query: {                    
                          redirect: router.currentRoute.fullPath                    
                        }                    
                    });       
                    break;
                // 404请求不存在                
                case 404:
                    // console.error('404')
                    alert('Resource not exist')
                    break;      
                default:
                    if(!(error.response.data.password.length > 0)){
                        alert('Unknown Error')
                    }
                  
                    break;       
            }
            return Promise.reject(error.response);
        }
    });